export const RESOURCE_TYPE_ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS =
	'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
export const RESOURCE_TYPE_ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS =
	'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
export const RESOURCE_TYPE_ADVANCED_ROADMAPS_SCENARIO_ID = 'ADVANCED_ROADMAPS_SCENARIO_ID';
export const RESOURCE_TYPE_ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID =
	'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';
export const RESOURCE_TYPE_PLANS_BACKLOG = 'PLANS_BACKLOG';
